angular.module('capability-ng-academic-planner').constant(
  'ngPreviewTermPlanConstant',
  Object.freeze({
    AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN: 'ap_preview_auto_generated_term_plan_shown'
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/constants/preview_term_plan_constants.ts